export default (TranslationService) => {
    // initial language detection to load enums etc in correct language
    // check service itself to find out priority list of detection
    TranslationService.changeLanguage();
};



// WEBPACK FOOTER //
// ./src/app/runs/translation/index.js